import React from 'react';
import { TextButton, Typography } from 'seagull';
import { NoMobileIllustration } from "./NoMobileIllustration";
import styles from "./MobileNotSupportedWarning.module.scss";
export default function MobileNotSupportedWarning(props) {
  const {
    onProceedAnyway
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": "mobile-not-supported-warning"
  }, /*#__PURE__*/React.createElement(NoMobileIllustration, null), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, null, "For optimal experience, we recommend using Anchor on a laptop or desktop.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "proceed-anyway",
    onClick: onProceedAnyway
  }, "Click here to proceed on mobile anyway"))));
}